import { sendWebsocketMessage } from '../../../../../App';
import { getMarketDataRoute } from '../../marketDataRouting';

/**
 * Request the number of expirations for an array of expiration dates (can't remember if it is for each expiration,
 *  or the total count of options for of all expiration dates sent).
 * @param {String} key we will send back this key in the return message in order for the component that sent this to know which message is his
 * @param {String} symbol the symbol that you are requesting the count for
 * @param {String} dataSource the datasource that you are requesting the count for
 * @param {[String]} dates all of the dates you would like to recieve the # of expirations for
 */
export function requestApproxStrikesPerExpirationDate(
  key,
  symbol,
  dataSource,
  dates,
  brokerage
) {
  const route = getMarketDataRoute({
    dataSource,
    brokerage,
    messageType: 'approxStrikesPerExpirationDate',
    symbol,
  });
  if (!route.valid) {
    return;
  }
  const msg = {
    messageType: 'approxStrikesPerExpirationDate',
    key,
    symbol,
    dataSource,
    dates,
    brokerage: route.brokerage,
  };
  sendWebsocketMessage(msg);
}
